import { useModals } from "@/features/modals/hooks";
import { type WidgetSettingsDefinition } from "@repo/api";
import { ListViewItem, pencilIcon } from "@repo/skapa";
import { t } from "@repo/translation";
import { translateKey } from "@repo/ui";

export const SelectionSettingsControl = ({
  settingDefinition,
  setting,
  setSetting,
}: {
  settingDefinition: WidgetSettingsDefinition;
  setting: Record<string, any>;
  setSetting: (newSetting: Record<string, object>) => void;
}) => {
  const { pushModal } = useModals();

  const values = setting[settingDefinition.id]
    ? setting[settingDefinition.id]
    : [];

  const mappedValueList =
    settingDefinition.stringValues?.map(
      (el) => [el, settingDefinition.translator?.(el) ?? el] as [string, string]
    ) ?? [];

  return (
    <ListViewItem
      control="navigational"
      title={translateKey(settingDefinition.title)}
      description={
        values?.length > 0
          ? values
              .map((v: string) => settingDefinition.translator?.(v) ?? v)
              .join(", ")
          : undefined
      }
      leadingIcon={pencilIcon}
      onClick={() => {
        pushModal({
          type: "SELECTION",
          title: t(settingDefinition.title),
          allValues: mappedValueList,
          selectedValues: values,
          onSelect: (newValues: string[]) => {
            setSetting({ ...setting, [settingDefinition.id]: newValues });
          },
          showSearch: settingDefinition.additionalControl?.showSearch ?? true,
          selectionMode:
            settingDefinition.additionalControl?.selectionMode ?? "MULTI",
        });
      }}
    />
  );
};
